var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27716 1.3959L7.597 1.63809L7.91837 1.39794C9.55026 0.178488 11.8252 0.520745 13.0581 2.154C14.1059 3.60813 13.992 5.57362 12.5837 6.91831L12.5836 6.91823L12.5756 6.92624L8.42708 11.0596C8.18856 11.2972 7.85402 11.4374 7.53221 11.4374C7.21039 11.4374 6.87585 11.2972 6.63734 11.0596L2.48886 6.92624C1.03082 5.47352 1.08663 3.14564 2.48886 1.74853C3.77836 0.463732 5.82298 0.29476 7.27716 1.3959Z",
    stroke: "white",
    strokeWidth: 1.06667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3004874208bfa8a806119f48a76bb41f.svg";
export { ForwardRef as ReactComponent };